<template>
  <CommunityCategoryPage
    :items="asyncData?.allPosts || []"
    :title="title"
    :post-type="postType"
    :category="asyncData?.category"
  />
</template>

<script setup lang="ts">
import { metaGen } from '~/util/metadata';
import { fetchCommunityCategory } from '~/util/contentstack/community';
import { useRootStore } from '~/store';

const { $bus }: any = useNuxtApp();
const rootStore = useRootStore();
const route = useRoute();
const { locale } = useI18n();
const postType = route?.params?.postType as string;
const title = postType === 'blog' ? 'Blog' : postType === 'event' ? 'Events' : 'Videos'; // TODO  - update

const event = useRequestEvent();

const { data: asyncData, error: asyncError } = await useAsyncData(async () => {
  const { allPosts, fetchRes, category } = await fetchCommunityCategory({
    postType,
    query: { locale: locale?.value },
    event,
  });
  if (!allPosts) throw createError({ statusCode: 404, message: 'Page not found' });

  return {
    allPosts,
    category,
    blogRes: fetchRes,
  };
});

useAsyncErrorHandling({
  error: asyncError.value,
  sentryWanted: false,
});

onMounted(() => {
  $bus.emit('pageView', {
    url: document.URL,
  });
});

const seo = asyncData.value?.category?.seo;
if (seo) {
  seo.page_title = `${postType.toUpperCase()} - ` + seo?.page_title;
  useHead({
    ...(metaGen(rootStore?.brandSettings, {
      ...(seo || {}),
    }) as any),
  });
} else {
  // TODO - update metadata for category
  useHead({
    ...(metaGen(rootStore?.brandSettings, {
      page_title: `Community ${title}`,
      page_description: `${title} - recipes, stories, product information, how-to, and more!`,
    }) as any),
  });
}
</script>
